import { stringify } from 'qs';
import { query, request } from 'src/utils/request';

// 获取工作流详情
export const getWorkFlowInfo = (params) => {
  return request('/zlb/api/expense/workflow/query', { 
    params,
  });
};

// 获取工作流详情
export const queryWorkFlowInfo = (params) => {
  return query(`/zlb/api/expense/workflow/query?${stringify(params)}`);
};